import { render } from "./AdPlacementTypeCardItem.vue?vue&type=template&id=1f6b4354&scoped=true"
import script from "./AdPlacementTypeCardItem.vue?vue&type=script&lang=js"
export * from "./AdPlacementTypeCardItem.vue?vue&type=script&lang=js"

import "./AdPlacementTypeCardItem.vue?vue&type=style&index=0&id=1f6b4354&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6b4354"]])

export default __exports__